/**
 * PGADarkNavy inverts in dark mode to a light gray so table/tab borders and
 * PageMessage titles stay visible. Do not change those token values.
 * Sidebar chrome keeps a dark rail by pairing light navy with surface-container.
 */
export const sidebarRailBgClass = "bg-extended-pgadarknavy-brand-color dark:bg-sys-brand-surface-container";

export const sidebarOnRailClass = "text-extended-pgadarknavy-brand-on-color dark:text-sys-brand-on-surface";

export const sidebarItemHoverClass =
  "hover:!bg-extended-pgadarknavy-brand-color-bright dark:hover:!bg-sys-brand-surface-container-high";

export const sidebarItemActiveClass =
  "bg-sys-brand-surface text-sys-brand-primary dark:bg-sys-brand-surface-container-highest";
